import apiFetch from '../../apiFetch'

export default function (campaignId, token) {
  return apiFetch({ endPoint: `dossier/campaign/${campaignId}/modal`, method: 'GET', body: null, token: token })
}
